import { useEffect, useState } from "react";
import { ScrollText } from "lucide-react";
import api from "../lib/api";

const ROLE_COLOR = {
  family: "text-[#34745C]",
  agency: "text-[#C48231]",
  admin: "text-[#2E5C50]",
};

export const AuditLogTable = () => {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(50);

  useEffect(() => {
    api.get("/admin/audit-logs", { params: { limit } }).then((res) => {
      setLogs(res.data.items);
      setTotal(res.data.total);
    });
  }, [limit]);

  return (
    <section className="fade-in-up">
      <h2 className="flex items-center gap-2 text-lg font-heading font-semibold mb-4">
        <ScrollText className="w-5 h-5 text-[#2E5C50]" strokeWidth={1.5} /> Audit log
      </h2>
      <div data-testid="audit-log-table" className="bg-white border border-[#E8E6E1] rounded-lg overflow-hidden">
        {logs.length === 0 ? (
          <p className="p-6 text-sm text-[#57605A]">No activity recorded yet.</p>
        ) : (
          <div className="max-h-[480px] overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0">
                <tr className="border-b border-[#E8E6E1] bg-[#F9F7F4]">
                  <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A]">Time</th>
                  <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A]">Actor</th>
                  <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A]">Action</th>
                  <th className="text-left px-5 py-3 text-xs uppercase tracking-[0.15em] font-semibold text-[#57605A] hidden md:table-cell">Detail</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id} data-testid={`audit-row-${log.id}`} className="border-b border-[#E8E6E1] last:border-0 hover:bg-[#F9F7F4]/60 transition-colors duration-150">
                    <td className="px-5 py-2.5 text-[#57605A] whitespace-nowrap">{new Date(log.created_at).toLocaleString()}</td>
                    <td className="px-5 py-2.5">
                      <span className="font-medium text-[#1C211F]">{log.actor_name}</span>
                      <span className={`ml-1.5 text-xs font-semibold uppercase ${ROLE_COLOR[log.actor_role] || ""}`}>{log.actor_role}</span>
                    </td>
                    <td className="px-5 py-2.5">
                      <code className="text-xs bg-[#F9F7F4] border border-[#E8E6E1] rounded px-1.5 py-0.5 text-[#2E5C50]">{log.action}</code>
                    </td>
                    <td className="px-5 py-2.5 text-[#57605A] hidden md:table-cell">{log.detail}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {total > logs.length && (
              <button
                data-testid="load-more-audit"
                onClick={() => setLimit((l) => l + 50)}
                className="w-full border-t border-[#E8E6E1] py-2.5 text-sm font-medium text-[#2E5C50] hover:bg-[#F9F7F4] transition-colors duration-150"
              >
                Load more ({logs.length} of {total})
              </button>
            )}
          </div>
        )}
      </div>
    </section>
  );
};
